import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    display: 'inline-flex',
    justify_content: 'space-between',
    align_items: 'center',
    border_style: 'solid',
    border_width: FOUNDATIONS.border_25,
    gap: FOUNDATIONS.spacing_100,
    border_radius: FOUNDATIONS.radius_comp_forms_chip_radiussize,
    padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_150}`,
    cursor: 'default',
});
export const leftIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
});
export const labelCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_550,
    font_weight: FONT_WEIGHT.font_weight_600,
    overflow: 'hidden',
    text_overflow: 'ellipsis',
});
export const rangeItemWrapperCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'inline-flex',
    align_items: 'center',
    justify_content: 'center',
    gap: FOUNDATIONS.spacing_100,
    margin_left: FOUNDATIONS.spacing_100,
});
export const rangeItemTextCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_550,
    font_weight: FONT_WEIGHT.font_weight_600,
});
export const rangeItemSeparatorCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_550,
    font_weight: FONT_WEIGHT.font_weight_600,
});
export const rangeIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
});
export const closeIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
});
//# sourceMappingURL=commonStyles.js.map